/* PopupComponent.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"];
import "./PopupComponent.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import { N0 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
var PopupComponentContainer = /*#__PURE__*/forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "div" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _2rkoiti9 _vchhusvi _1e0c1ule _bfhk1j9a _16qs1sus _nt751r31 _49pcglyw _1hvw1o36", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  PopupComponentContainer.displayName = 'PopupComponentContainer';
}
export var PopupComponent = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(PopupComponentContainer, _extends({}, props, {
    "data-testId": 'confluence-search-datasource-popup-container',
    ref: ref
  }));
});